var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sidebar-wrapper" } }, [
    _c(
      "ul",
      {
        staticClass: "sidebar-nav nav-pills nav-stacked",
        attrs: { id: "menu" }
      },
      [
        _vm._l(_vm.menuArray, function(menu, m_index) {
          return [
            _c(
              "li",
              {
                key: "m menu " + m_index,
                class: ["menuCommon", menu.slug, { active: menu.isActive }],
                attrs: { id: menu.slug }
              },
              [
                menu.routerlink.name == "BackendDocuments"
                  ? [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: menu.routerlink.name,
                              params: { slug: menu.slug }
                            }
                          }
                        },
                        [
                          _c("i", {
                            class: "spm-nav-menu fa-stack fa-lg " + menu.icon
                          }),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(_vm._s(_vm.stringTrim(menu.name, 22)))
                          ])
                        ]
                      )
                    ]
                  : [
                      _c(
                        "router-link",
                        { attrs: { to: { name: menu.routerlink.name } } },
                        [
                          _c("i", {
                            class: "spm-nav-menu fa-stack fa-lg " + menu.icon
                          }),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(_vm._s(_vm.stringTrim(menu.name, 22)))
                          ])
                        ]
                      )
                    ]
              ],
              2
            )
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35a79c62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35a79c62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Sidebar.vue
// module id = null
// module chunks = 